import { atom } from 'recoil'

export const modalSendingMessageState = atom({
  key: 'messagePreviewModalSendingMessageState',
  default: {
    show: false
  }
})

export const modalBuyCollaborationState = atom({
  key: 'messagePreviewModalBuyCollaborationState',
  default: {
    show: false
  }
})
